import {
  QueryKey,
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient
} from 'react-query'

import {
  createUserAddresses,
  createUserShipping,
  getEstimateRate,
  updateUserShipping
} from 'app/services/Api/shipping'
import { listingKeys } from 'app/services/Query/listing/listing.keys'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

import { shippingKeys } from './shipping.keys'

interface ShippingMutation {
  createUserShipping: {
    key: QueryKey
    request: UseMutateAsyncFunction<ShippingModel, string, Partial<ShippingDTO>>
  }
  createUserAddresses: {
    key: QueryKey
    request: UseMutateAsyncFunction<Address, string, AddressDTO>
  }
  updateUserShipping: {
    key: QueryKey
    request: UseMutateAsyncFunction<
      ShippingModel,
      string,
      { slug?: string; data: Partial<ShippingDTO> }
    >
  }
  getEstimateRate: {
    key: QueryKey
    request: UseMutateAsyncFunction<EstimateRateModel, string, EstimateRate>
  }
}

const shippingMutationConfig: ShippingMutation = {
  createUserShipping: {
    key: shippingKeys.createUserShipping(),
    request: createUserShipping
  },
  createUserAddresses: {
    key: shippingKeys.createUserAddress(),
    request: createUserAddresses
  },
  updateUserShipping: {
    key: shippingKeys.updateUserShipping(),
    request: updateUserShipping
  },
  getEstimateRate: {
    key: shippingKeys.getEstimateRate(),
    request: getEstimateRate
  }
}

export const useCreateShippingMutation = () => {
  const { createUserShipping: config } = shippingMutationConfig
  const queryClient = useQueryClient()

  const state = useMutation(config.key, config.request, {
    onSuccess: () => {
      if (IS_NATIVE_APP) {
        queryClient.invalidateQueries(listingKeys.listing)
      }
    }
  })

  return state
}

export const useCreateAddressMutation = () => {
  const { createUserAddresses: config } = shippingMutationConfig

  const state = useMutation(config.key, config.request)

  return state
}

export const useUpdateUserShippingMutation = () => {
  const { updateUserShipping: config } = shippingMutationConfig
  const queryClient = useQueryClient()

  const state = useMutation(config.key, config.request, {
    onSuccess: () => {
      if (IS_NATIVE_APP) {
        queryClient.invalidateQueries(listingKeys.listing)
      }
    }
  })

  return state
}

export const useGetEstimateRateMutation = () => {
  const { getEstimateRate: config } = shippingMutationConfig

  const state = useMutation(config.key, config.request)

  return state
}
